import selectLoadmore from './select-loadmore';
import dragDialog from './drag-dialog'

const install = function (Vue) {
  Vue.directive('select-loadmore', selectLoadmore);
  Vue.directive('drag-dialog', dragDialog);
};

export default install;
